import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@fortem-monorepo/react-ui'

type Props = React.PropsWithChildren<{ title: string; description: string; pending?: boolean; onClose: () => void }>

export const AccruedInterestDialogFrame = ({ title, description, pending = false, onClose, children }: Props) => (
  <Dialog
    open
    onOpenChange={(open) => {
      if (!open && !pending) onClose()
    }}
  >
    <DialogContent
      className="max-h-[90svh] overflow-y-auto sm:max-w-3xl"
      onEscapeKeyDown={(event) => {
        if (pending) event.preventDefault()
      }}
      onInteractOutside={(event) => {
        if (pending) event.preventDefault()
      }}
    >
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </DialogHeader>
      {children}
    </DialogContent>
  </Dialog>
)
